import request from "../../../../helper/request";

const orderApi = {
  getOrderList: (params) => {
    return request.get("/orders", {
      params
    });
  },
  getOrderRoutes: (id) => {
    return request.get(`/orders/${id}/routes`);
  },
  delete: (id) => {
    return request.delete(`/orders/${id}`);
  },
  createActiveOrder: async (data) => {
    console.log("===CREATE ACTIVE ORDER - FRONTEND===", {
      endpoint: "/orders",
      payload: data
    });
    const response = await request.post("/orders", data);
    console.log("===CREATE ACTIVE ORDER RESPONSE===", response);
    return response;
  },
  getOrder: (id) => {
    return request.get(`/orders/${id}`);
  },
  getJobOrder: (id) => {
    return request.get(`/jobs/${id}`);
  },
  addJobToRoute: (data) => {
    return request.post(`/jobs/add-job-to-route`, data);
  },
  optimizeOrder: (data) => {
    return request.post(`/routes/orders-optimize`, data);
  },
  optimizeExistingOrder: async (data) => {
    console.log("===OPTIMIZE===", {
      endpoint: `/routes/existing-order-optimize`,
      payload: data
    });
    const response = await request.post(`/routes/existing-order-optimize`, data);
    console.log("===OPTIMIZE RESPONSE===", response);
    return response;
  },
  sortOrderRoute: (data) => {
    return request.post(`/routes/orders-sort`, data);
  },
  // Synchronous, unlike the two above: the solution comes back in the response body rather
  // than through the routing engine's callback and polling.
  fixedOrderRoute: (data) => {
    return request.post(`/routes/orders-fixed-order`, data);
  },
  fetchPricingEstimate: (data) => {
    return request.post(`/pricing/estimate`, data);
  }
};

export default orderApi;
